import Vue from 'vue';
import Router from 'vue-router';
import BasicLayout from '../layouts/BasicLayout.vue';
import BlankLayout from '../layouts/BlankLayout.vue';

Vue.use(Router);

export default new Router({
  mode: 'history',
  // mode: 'hash',
  base: process.env.BASE_URL,
  routes: [
    {
      path: '/ticket_check',
      name: 'ticket_check',
      component: () => import('../views/TicketCheck'),
    },
    {
      path: '/ticket_check_result',
      name: 'ticket_check_result',
      component: () => import('../views/TicketCheckResult'),
    },
    {
      path: '/tickets_register',
      name: 'register',
      component: () => import('../views/Register'),
    },
    {
      path: '/',
      redirect: '/tickets_list',
      name: 'index',
      component: BasicLayout,
      children: [
        {
          path: '/tickets_list',
          name: 'tickets_list',
          component: () => import('../views/ticket/TicketsList'),
        },
        // 购票须知
        {
          path: '/ticket_instructions',
          name: 'ticket_instructions',
          component: () => import('@/views/ticket/TicketsList/component/introduce'),
        },
        {
          path: '/ticket_description',
          name: 'ticket_description',
          component: () => import('@/views/ticket/TicketsList/component/description.vue'),
        },
        {
          path: '/orders_list',
          name: 'orders_list',
          component: () => import('../views/OrdersList'),
        },
        {
          path: '/ticket_detail',
          name: 'ticket_detail',
          component: () => import('../views/ticket/TicketDetail'),
        },
        {
          path: '/ticket_success',
          name: 'ticket_success',
          component: () => import('../views/ticket/TicketSuccess'),
        },
        {
          path: '/bonus_detail',
          name: 'bonus_detail',
          component: () => import('../views/BonusDetail'),
        },
        {
          path: '/user_info',
          name: 'user_info',
          redirect: '/user_info/index',
          component: BlankLayout,
          children: [
            {
              path: '/user_info/index',
              name: 'user_info_index',
              component: () => import('../views/userInfo/UserInfo'),
            },
            {
              path: '/user_info/detail',
              name: 'user_info_detail',
              component: () => import('../views/userInfo/UserDetail'),
            },
            // {
            //   path: '/user_info/recharge',
            //   name: 'user_info_recharge',
            //   component: () => import('../views/userInfo/UserInfoRecharge'),
            // },
            {
              path: '/user_info/recharge_list',
              name: 'user_info_recharge_list',
              component: () => import('../views/userInfo/UserInfoRechargeList'),
            },
            {
              path: '/user_info/consume_list',
              name: 'user_info_consume_list',
              component: () => import('../views/userInfo/UserInfoConsumeList'),
            },
            {
              path: '/user_info/balance_list',
              name: 'user_info_balance_list',
              component: () => import('../views/userInfo/UserInfoBalanceList'),
            },
            {
              path: '/user_info/integral_list',
              name: 'user_info_integral_list',
              component: () => import('../views/userInfo/UserInfoIntegralList'),
            },
            {
              path: '/user_info/hours_list',
              name: 'user_info_hours_list',
              component: () => import('../views/userInfo/UserInfoHoursList'),
            },
            {
              path: '/user_info/participation_list',
              name: 'user_info_participation_list',
              component: () => import('../views/userInfo/UserInfoParticipationList'),
            },
            {
              path: '/user_info/share',
              name: 'user_info_share',
              component: () => import('../views/userInfo/UserInfoShare'),
            },
            {
              path: '/user_info/rebate_list',
              name: 'user_info_rebate_list',
              component: () => import('../views/userInfo/UserInfoRebateList'),
            },
            {
              path: '/user_info/hours_rebate_list',
              name: 'user_info_hours_rebate_list',
              component: () => import('../views/userInfo/UserInfoHoursRebateList'),
            },
            {
              path: '/user_info/withdraw',
              name: 'user_info_withdraw',
              component: () => import('../views/userInfo/UserInfoWithdraw'),
            },
            {
              path: '/user_info/agent',
              name: 'user_info_agent',
              component: () => import('../views/userInfo/UserInfoAgent'),
            },
            {
              path: '/user_info/bonus_scan',
              name: 'user_info_bonus_scan',
              component: () => import('../views/BonusScan'),
            },
            // 我的优惠券
            {
              path: '/user_info/my_coupon',
              name: 'user_info_my_coupon',
              component: () => import('../views/userInfo/UserInfoCoupon/myCoupon.vue'),
            },
            // 领取优惠券
            {
              path: '/user_info/get_coupon',
              name: 'user_info_get_coupon',
              component: () => import('../views/userInfo/UserInfoCoupon/getCoupon.vue'),
            }
          ]
        }
      ]
    },
    {
      path: '/ticket_detail_list',
      name: 'ticket_detail_list',
      component: () => import('../views/ticket/TicketDetailList'),
    },
    // 开启储物柜
    {
      path: '/mylocker',
      name: 'mylocker',
      component: () => import('../views/Locker'),
    },
    {
      path: '*',
      name: '404',
      redirect: '/',
    },
  ],
});
